import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 58 56"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#9B8C7C",
  d: "M49.927 38.123c-3.287 8.085-10.181 13.842-18.45 15.412C19.644 51.279 11.06 40.549 11.06 28S19.645 4.726 31.47 2.465c8.177 1.56 15.036 7.23 18.358 15.174l.575 1.381L58 11.81l-.526-.72C52.32 4.045 44.483 0 35.972 0c-1.508 0-3.026.131-4.5.389A26.272 26.272 0 0 0 26.975 0C12.102 0 0 12.558 0 28s12.102 28 26.976 28c1.508 0 3.021-.131 4.5-.389 1.474.258 2.988.389 4.496.389 8.486 0 16.309-4.02 21.458-11.032l.511-.69-7.42-7.614-.594 1.459Zm5.346-26.547-4.142 3.934C48.212 9.442 43.195 4.629 37.16 2.07c7.076.345 13.611 3.763 18.112 9.505ZM2.063 28c0-13.9 10.545-25.282 23.733-25.929C15.684 6.35 9.002 16.565 9.002 28c0 11.435 6.682 21.65 16.794 25.929C12.603 53.282 2.064 41.9 2.064 28Zm53.19 16.448c-4.496 5.722-11.016 9.13-18.072 9.48 6.088-2.58 11.134-7.457 14.038-13.617l4.034 4.142v-.005Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render() { return h(NuxtIcon, {icon: {render}}) } }